// extracted by mini-css-extract-plugin
export var mintFighterModal = "index-module--mint-fighter-modal--eGxh3";
export var mintFighterModalContent = "index-module--mint-fighter-modal-content--K-4P3";
export var mintFighterModalContentBg = "index-module--mint-fighter-modal-content-bg--ZAKpO";
export var mintFighterModalTitle = "index-module--mint-fighter-modal-title--oQgE9";
export var mintFighterModalText = "index-module--mint-fighter-modal-text--L6Q4S";
export var mintFighterModalClose = "index-module--mint-fighter-modal-close--Q2T1M";
export var mintFighterModalButton = "index-module--mint-fighter-modal-button--al6eV";
export var marketplaces = "index-module--marketplaces--7UZ56";
export var marketplaceItem = "index-module--marketplace-item--Gx3ff";
export var marketplaceItemImage = "index-module--marketplace-item-image--8zYkQ";
export var marketplaceItemTitle = "index-module--marketplace-item-title--G4S4f";